export type RuntimeCleanup = () => void;

export class RuntimeLifecycle {
  private readonly cleanups: RuntimeCleanup[] = [];
  readonly controller = new AbortController();

  get signal(): AbortSignal {
    return this.controller.signal;
  }

  add(cleanup: RuntimeCleanup): void {
    this.cleanups.push(cleanup);
  }

  on<K extends keyof HTMLElementEventMap>(
    element: HTMLElement,
    type: K,
    listener: (event: HTMLElementEventMap[K]) => void,
    options?: AddEventListenerOptions,
  ): void {
    element.addEventListener(type, listener as EventListener, options);
    this.add(() => element.removeEventListener(type, listener as EventListener, options));
  }

  destroy(): void {
    this.controller.abort();
    while (this.cleanups.length) {
      const cleanup = this.cleanups.pop();
      try {
        cleanup?.();
      } catch {
        // Destroy must be best-effort and never throw during navigation/unload.
      }
    }
  }
}
